export const columnFields = [
	'id',
	'name',
	'formula',
	'additionalParameterIds',
	'createdAt',
	'updatedAt',
] as const;
